var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "header" },
    _vm._l(_vm.tabs, function (tab) {
      return _c(
        "div",
        {
          key: tab.id,
          staticClass: "header-item",
          class: { active: _vm.isActiveTab(tab) },
          on: {
            click: function ($event) {
              return _vm.onChangeTab(tab)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t(tab.labelKey)) + " ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }